module.exports = __webpack_public_path__ + "static/media/MarsEMS_15.4147fef5.webp";